import React, { memo } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Grid,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { accordionSx } from "./styles";
import { InvoiceBreakdown } from "./InvoiceBreakdown";
import { InvoiceAccordionDetails } from "./InvoiceAccordionDetails";

/**
 * Panel de una tasa dentro del desglose de un permiso: la cabecera con IVA,
 * PU sin IVA y totales, y adentro un renglon por metodo de pago.
 *
 * Vive dentro del Collapse del permiso, asi que no participa de la cuadricula
 * de las filas principales y no puede desalinear sus columnas.
 */
export const TaxBreakdownAccordion = memo(
  ({ data, creLicense, selectedPayments, onTogglePayment, originalPayments }) => {
    const { taxRate, payments } = data;

    return (
      <Grid item xs={12}>
        <Card sx={{ ...accordionSx.border, boxShadow: 3 }}>
          <Accordion
            defaultExpanded
            disableGutters
            sx={{ backgroundColor: "rgba(246, 246, 246 ,1)" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={accordionSx.box}
            >
              <InvoiceBreakdown data={data} />
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0, flexDirection: "column" }}>
              <InvoiceAccordionDetails
                data={{ payments, taxRate, creLicense }}
                selectedPayments={selectedPayments}
                onTogglePayment={onTogglePayment}
                originalPayments={originalPayments}
              />
            </AccordionDetails>
          </Accordion>
        </Card>
      </Grid>
    );
  },
);
